// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_rose_relief/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_rose_relief: ModuleSchema = {
  "id": "core_rose_relief",
  "uniqueId": "B3D_ROSE1",
  "createdAt": "2026-10-23T10:14:27+07:00",
  "updatedAt": "2026-10-23T10:14:27+07:00",
  "label": "Rose Cluster Relief",
  "description": "Reusable printable rose cluster relief (CG_ROSE01).",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_ROSE01",
    "rose",
    "relief"
  ],
  "sliders": [
    {
      "key": "flowerDiameter",
      "label": "Flower diameter",
      "min": 4,
      "max": 50,
      "default": 14,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "spacing",
      "label": "Flower spacing",
      "min": 3,
      "max": 60,
      "default": 11,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "flowerCount",
      "label": "Flowers",
      "min": 1,
      "max": 5,
      "default": 3,
      "step": 1,
      "integerOnly": true
    },
    {
      "key": "baseDepth",
      "label": "Backing thickness",
      "min": 0.8,
      "max": 5,
      "default": 1.6,
      "step": 0.2,
      "unit": "mm"
    },
    {
      "key": "reliefDepth",
      "label": "Relief height",
      "min": 0.4,
      "max": 3,
      "default": 1.2,
      "step": 0.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Backing",
      "default": "#F9D5DD",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "rose",
      "label": "Rose relief",
      "default": "#E99AAC",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
